/* ==========================================================================
   HOME PASSION · taksit satiri

   Urun sayfasinda fiyatin hemen altina, Sepete Ekle'nin ustune yazar.
   Taksit sayisi header ayarindan (window.HP_DC.taksit) gelir — tek yerden
   yonetiliyor, her sayfada ayni. Fiyat degistikce (adet kademesi, varyant)
   kendini gunceller.
   ========================================================================== */
(function(){
  'use strict';
  var n = (window.HP_DC && parseInt(window.HP_DC.taksit,10)) || 0;
  if(!n) return;

  function parseTL(s){
    if(!s) return 0;
    var t = String(s).replace(/[^\d.,]/g,'');
    if(t.indexOf(',')>-1){ t = t.replace(/\./g,'').replace(',','.'); }
    return parseFloat(t)||0;
  }
  function money(v){
    return new Intl.NumberFormat('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2}).format(v)+' TL';
  }

  function mount(){
    var price = document.querySelector('.hp-pd-price [data-total]');
    if(!price) return;
    var anchor = document.querySelector('.hp-pd-unit') || price.parentElement;

    var el = document.querySelector('.hp-pd-taksit');
    if(!el){
      el = document.createElement('div');
      el.className = 'hp-tak hp-pd-taksit';
      el.innerHTML = '<svg viewBox="0 0 24 24"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg><span></span>';
      anchor.parentNode.insertBefore(el, anchor.nextSibling);
    }

    var v = parseTL(price.textContent);
    if(v<=0){ el.style.display='none'; return; }
    el.style.display='';
    el.querySelector('span').innerHTML = 'veya <b>'+n+' taksit × '+money(v/n)+'</b> · faizsiz';
  }

  function boot(){
    mount();
    var price = document.querySelector('.hp-pd-price [data-total]');
    if(price && window.MutationObserver){
      new MutationObserver(mount).observe(price, {childList:true, characterData:true, subtree:true});
    }
  }

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
